module.exports = __webpack_public_path__ + "img/News_item_4.a465b3ce.jpg";